
import ClientHead from "@/components/main/core/ClientHead";
import faqMain from "@/components/main/faq/faqMain";
import RedSection from "@/components/main/core/RedSection";
import CheckBox from "@/components/main/core/CheckBox";

export default {
  head() {
    const title = 'Frequently Asked Questions (FAQ) - Catching Cheaters | iFindCheaters';
    const description = 'Discover answers to common questions about catching cheaters online with iFindCheaters.com. Learn about sign-up, products, billing, and more to make informed decisions about verifying potential infidelity.';

    return {
      title: title,
      meta: [
      {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Catching Cheaters Online, Best Websites to Find Cheaters, Cheater Lookup Services, Online Cheater Detection, Cheater Investigation FAQs, How to Catch a Cheater, Infidelity Detection Services, Catching Cheaters FAQs'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/faq/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "iFindCheaters",
                "item": "https://ifindcheaters.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "FAQs",
              }
            ]
          }
        },
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "How do I get free report?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The FREE TRIAL runs a scan on selected services chosen by our tech team so you can see how it works in real time. To receive a full report requires the purchase of search credits for the online platforms or apps you want to scan."
                }
              },
              {
                "@type": "Question",
                "name": "Why is FREE TRIAL blurred?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The FREE TRIAL is a sample to illustrate how the service works. To see complete results for more than the sampled platforms requires purchase of at least one search credit."
                }
              },
              {
                "@type": "Question",
                "name": "Why didn't I receive a verification email",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Your verification email may have gone to your SPAM or BULK folder because they are generated automatically. Depending on your internet service provider or if you are trying to access iFindCheaters.com from a LAN terminal there may be filters that block automated email. We recommend you only access the site from your personal device. If your verification email does not appear within 10-15 minutes, please let us know."
                }
              },
              {
                "@type": "Question",
                "name": "Why is the SCAN/SEARCH taking so long?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The SCAN/SEARCH times may vary depending on what time you submit your request. The average is 2-5 minutes, but it may take longer based on the search you request, and if the sites being scanned are receiving heavy user traffic."
                }
              },
              {
                "@type": "Question",
                "name": "How do I see the SCAN/SEARCH reports",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "As soon as you have entered your payment information the results will become visible. For your convenience, you can also download the report as a printable PDF document."
                }
              },
              {
                "@type": "Question",
                "name": "Will the report emailed to me?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "To protect confidentiality, we do not send reports via email. You will receive an email notification that the report is ready for viewing on the site."
                }
              },
              {
                "@type": "Question",
                "name": "Do you provide partner's log information (username and password) for the sites or apps they have active accounts on?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Our service can confirm the existence of active accounts linked to your partner’s name and email address. We cannot access their passwords or materials they may have uploaded to those accounts. To do so would be an invasion of privacy and thus illegal."
                }
              },
              {
                "@type": "Question",
                "name": "DATING/ALTERNATIVE LIFESTYLE SITES OR SOCIAL MEDIA & MOBILE CHAT/HOOK-UP APPS",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "FLEX – This option allows you to purchase as many search credits as you think you will need and use them individually to generate searches with any name or email address you choose. MONTHLY – This option runs a daily scan using one or more email addresses. You can request notification of results daily, or only when new activity is detected. Monthly plans have recurring billing. If you cancel the plan reports will continue to be generated until the end of that billing cycle but there will be no further charges. ULTIMATE – This option gets you 15 search credits for each of our service areas providing you a comprehensive view of one person’s activity, or the flexibility to search for different people on different services. You decide when to scan each service and who your person of interest is. If they have multiple email addresses you can scan them all to be sure."
                }
              },
              {
                "@type": "Question",
                "name": "LISTING LOCATOR",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "This service enables you to get information to verify identity, relationship status, physical addresses, telephone numbers and email. You can search for this information by entering their name, phone number, physical address or email. Whatever piece of information they have given you can be verified in one simple search."
                }
              },
              {
                "@type": "Question",
                "name": "LIVE ADULT STREAMS OR XXX WEBSITES",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "XXX FLEX – Here also you have the option of purchasing individual or bundled search credits depending upon your needs. Learn if your partner is a consumer/subscriber to porn online. XXX MONTHLY – These options run daily scans to monitor new activity and report notifications can be generated daily or whenever new activity is detected. Monthly plans have recurring billing. If you cancel the plan reports will continue to be generated until the end of that billing cycle but there will be no further charges. XXX ULTIMATE – This package includes 15 search credits for use on each of our service areas. You get to choose when, and which service area to search on whomever you want. If your partner has multiple email addresses this option gives you a comprehensive look at their activity across the board."
                }
              },
              {
                "@type": "Question",
                "name": "TINDER BLASTER",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "TINDER BLASTER BASIC – Enter the name, specific age, specific location you believe your partner may be using. A list of users matching those parameters. If you find your partner with an additional search credit you can request a PROFILE UPDATE that will provide you their Tinder ID and full profile details. TINDER BLASTER EXTENDED – If the BASIC search is too narrow with an additional search credit you can provide an age range and broad location radius that sweeps a wider area of activity. Once you find your partner you can request a PROFILE UPDATE that will provide you their Tinder ID and full profile details."
                }
              },
              {
                "@type": "Question",
                "name": "This is free?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "There is no cost to register or to browse the site. There is a FREE TRIAL available for either selected DATING/ALTERNATIVE LIFESTYLE SITES or selected SOCIAL MEDIA & MOBILE CHAT/HOOK-UP APPS. If you have requested a search using your partner’s name and email address, to access the complete results you will need to purchase one of the individual search credit options or a package plan. The technical maintenance and constant research and development required to keep our service current is a costly process, but we try to keep our prices as reasonable as possible. Every report is also downloadable as a PDF document."
                }
              },
              {
                "@type": "Question",
                "name": "Can I cancel the FREE TRIAL at any time to avoid being billed?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "No payment method is required to generate the FREE TRIAL scan. If you have purchased a Monthly option, you can request cancellation and will not be billed again at the end of the billing cycle."
                }
              },
              {
                "@type": "Question",
                "name": "How will this charge appear on my bank or credit card statement?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "When you use your credit or debit card the charge will appear as iFC Search Products on your monthly statement"
                }
              },
              {
                "@type": "Question",
                "name": "How can I pay so it won't appear on my bank or credit card statement?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "If you do not want to provide a debit or credit card for fear of raising suspicion you may use a prepaid card or create a PayPal account, which many people use for shopping online."
                }
              },
              {
                "@type": "Question",
                "name": "How can I pay with a prepaid card?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "You enter the information for a prepaid card just as you would any other credit or debit card. There is technically no billing address with a prepaid card, but the fields will still need to be completed for the charge to be processed."
                }
              },
              {
                "@type": "Question",
                "name": "How can I cancel my subscription?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "When you have logged in, the menu to the left on your DASHBOARD page contains a cancellation option. If you have a monthly plan subscription, the account will remain active until the next billing cycle begins."
                }
              },
              {
                "@type": "Question",
                "name": "How do I find out if my partner is cheating?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "iFindCheaters offers a variety of services to help you discover if you partner is active online. Once you know which sites or apps they are users of, and then you can do more research. You may want to start by verifying that the information they have given you is genuine by using our LISTING LOCATOR service."
                }
              },
              {
                "@type": "Question",
                "name": "How do I learn if my partners is on DATING/ALTERNATIVE LIFESTYLE SITES?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "When you enter their full name (first and last) and an email address our algorithms will search the databases of the bundle of sites/platforms or apps you have chosen. If they have an active profile connected to the information you have entered it will be discovered. Once you know what services they are using, you can follow up to see if they are still on the internet dating market."
                }
              },
              {
                "@type": "Question",
                "name": "Can I check by entering a name only?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Most online sites/apps require users to enter a name and email address or mobile phone number. They may not be using their given name, maybe a nickname instead, having an email address increases the search power. Our LISTING LOCATOR can help you find other phone numbers or email addresses your partner might be using."
                }
              },
              {
                "@type": "Question",
                "name": "Can I enter more than one email?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Once you have purchased search credits you can use them to search using any email you think might be involved. The Monthly options allow you to run searches on several emails at the same time."
                }
              },
              {
                "@type": "Question",
                "name": "How does mobile monitoring work?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "If you notice unfamiliar numbers on your partner’s phone you can use our LISTING LOCATOR service to discover whom that number belongs to. We also have active mobile phone monitoring services that will be launching soon."
                }
              },
              {
                "@type": "Question",
                "name": "Other questions please submit this FORM",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "If you haven't found the answer to your question please let us know and submit this FORM. We value your input because it helps us offer better service."
                }
              }
            ]
          }
        }
      ]
    };
  },
  name: "faq",
  layout: 'clientLayout',
  mixins: [],
  components: { ClientHead, faqMain, RedSection, CheckBox },
  data() {
    return {};
  },
  computed: {
    faqTitle() {
      switch (this.$store.state.faqModule.question) {
        case 1: return 'SIGN UP/REGISTRATION';
        case 2: return 'PRODUCTS & SERVICES';
        case 3: return 'BILLING OPTIONS & REFUND POLICY';
        case 4: return 'SEARCH PROCEDURES & OPTIONS';
      }
    }
  },
  mounted() {},
  methods: {}
};
